import React, {useEffect, useState} from "react";
import {withRouter} from "react-router";
import {DemandValidation} from 'constants/DemandValidation';
import {connect} from "react-redux";
import Loading from "components/Loading";
import GridBlock from "components/GridBlock";
import Tr from "translations/Translations";
import BoldTypography from "components/BoldTypography";
import DemandValidationMessages from "components/DemandValidationMessages";
import AdditionalRoundPassiveService from "services/AdditionalRoundPassiveService";
import AdditionalRoundPassiveTable from "./components/AdditionalRoundPassiveTable";
import Button from "../../../../../../../components/Button";
import AdditionalRoundPassiveCreatePopup from "./components/AdditionalRoundPassiveCreatePopup";
import {AdditionalRoundStatusesPending} from "../../../../../../../constants/AdditionalRoundStatus";
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    button: {
        float: 'right',
        marginBottom: theme.spacing()
    }
}));

function AdditionalRoundPassive(
    {
        match,
        additionalPassiveRounds,
        demandValidation
    }) {
    const classes = useStyles();
    const curDemandValidation = DemandValidation.ADDITIONAL_ROUND_PASSIVE;
    const demandId = match.params.id;
    const section = demandValidation.find(x => x.section === curDemandValidation);
    const editable = section ? section.editable : false;

    const [refresh, setRefresh] = useState(0);
    const [createPopupOpened, setCreatePopupOpened] = useState(false);

    useEffect(() => {
        AdditionalRoundPassiveService.getAdditionalPassiveRoundsList(demandId);
        return () => AdditionalRoundPassiveService.clearResources(AdditionalRoundPassiveService.ADDITIONAL_PASSIVE_ROUNDS_LIST_RESOURCE_ID);
    }, [demandId, refresh])

    const refreshData = () => {
        setRefresh(x => x+1)
    }

    if (!additionalPassiveRounds) return <Loading/>;

    return (<GridBlock column>
        <DemandValidationMessages editable={editable} section={section}/>

        {
            editable && <Button
                className={classes.button}
                onClick={() => setCreatePopupOpened(true)}
                disabled={!(additionalPassiveRounds.length === 0 || AdditionalRoundStatusesPending.indexOf(additionalPassiveRounds[0].status) === -1)}
            >{Tr('additional_round_create_additional_offers_button')}</Button>
        }


        {!additionalPassiveRounds?.length ?
            <BoldTypography align='center' variant="h6">{Tr('no_options')}</BoldTypography>
            :
            <>
                <AdditionalRoundPassiveTable
                    demandId={demandId}
                    additionalPassiveRounds={additionalPassiveRounds}
                    working={false}
                    editable={editable}
                />
            </>}
        {
            createPopupOpened &&
            <AdditionalRoundPassiveCreatePopup
                demandId={demandId}
                onCancel={() => setCreatePopupOpened(false)}
                onSuccess={() => {
                    refreshData();
                    setCreatePopupOpened(false);
                }}
            />
        }
    </GridBlock>)
}

export default connect((state) => ({
    additionalPassiveRounds: state.resources[AdditionalRoundPassiveService.ADDITIONAL_PASSIVE_ROUNDS_LIST_RESOURCE_ID],
    demandValidation: state.resources.demandValidation,
}), {})(withRouter(AdditionalRoundPassive));

